import type { UiActionParameters } from '../parameters/ui-action'

import { createEvent, sample } from 'effector'

export type PlayerRecommendationsShownPayload = {
  contentId?: string
  contentType?: string
  contentName?: string
  programName?: string
}

export const playerRecommendationsShown =
  createEvent<PlayerRecommendationsShownPayload>()

export const playerRecommendationsShownTracked =
  createEvent<UiActionParameters>()

sample({
  clock: playerRecommendationsShown,
  fn: (params): UiActionParameters => ({
    contentId: params.contentId,
    contentType: params.contentType,
    contentName: params.contentName,
    programName: params.programName,
    featureIdentifier: 'playback_actions',
    uiElementType: 'recommendations_row',
    uiElementName: 'recommendations_shown',
    actionName: 'show',
  }),
  target: playerRecommendationsShownTracked,
})
